// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The one details-view header, shared by all three catalogs.
 *
 * There were two stylesheets and three results: the Data panel put its icon,
 * title and Export on one row inside \`.pageHeader\`; the Agent and Node modals
 * stacked an icon and a title in \`.header\` and pushed the action into the body.
 * Different paddings, different title sizes, different action placement - the
 * same screen looked like a different product depending on which catalog you
 * opened it from, and every attempt to line them up moved one and not the
 * others. One rule now, so they cannot drift again.
 */

.MPLakXmluYICSLHsHLwZ {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  /* The right inset clears ModalShell's \`.closeX\`, which is absolutely
     positioned at top/right 16px. Without it the header's action rendered
     underneath the close button. */
  padding: 24px 68px 16px 24px;
  border-bottom: 1px solid var(--curio-border);
  background: var(--curio-page-bg);
}

.hne4oerXDLKOrBvzXNNp {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  min-width: 0;
}

.QPkJX2o5G34SP3N9zTLh {
  min-width: 0;
}

.a9AzVLDpIqzMl_JRn000 {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
  color: var(--curio-text-primary);
  overflow-wrap: anywhere;
}

.TKgMrBwYmg4j9wYoF4Ff {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--curio-text-secondary);
}

.feP4lHmOjIviwcL5w5pn {
  display: flex;
  align-items: center;
  gap: 8px;
  /* Never squeezed by a long title. */
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/catalog/CatalogDetailHeader.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT;;mCAEiC;EACjC,4BAA4B;EAC5B,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,cAAc;AAChB","sourcesContent":["/*\n * The one details-view header, shared by all three catalogs.\n *\n * There were two stylesheets and three results: the Data panel put its icon,\n * title and Export on one row inside `.pageHeader`; the Agent and Node modals\n * stacked an icon and a title in `.header` and pushed the action into the body.\n * Different paddings, different title sizes, different action placement - the\n * same screen looked like a different product depending on which catalog you\n * opened it from, and every attempt to line them up moved one and not the\n * others. One rule now, so they cannot drift again.\n */\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  /* The right inset clears ModalShell's `.closeX`, which is absolutely\n     positioned at top/right 16px. Without it the header's action rendered\n     underneath the close button. */\n  padding: 24px 68px 16px 24px;\n  border-bottom: 1px solid var(--curio-border);\n  background: var(--curio-page-bg);\n}\n\n.titleBlock {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  min-width: 0;\n}\n\n.titleText {\n  min-width: 0;\n}\n\n.title {\n  margin: 0 0 6px;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0;\n  color: var(--curio-text-primary);\n  overflow-wrap: anywhere;\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--curio-text-secondary);\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  /* Never squeezed by a long title. */\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `MPLakXmluYICSLHsHLwZ`,
	"titleBlock": `hne4oerXDLKOrBvzXNNp`,
	"titleText": `QPkJX2o5G34SP3N9zTLh`,
	"title": `a9AzVLDpIqzMl_JRn000`,
	"subtitle": `TKgMrBwYmg4j9wYoF4Ff`,
	"actions": `feP4lHmOjIviwcL5w5pn`
};
export default ___CSS_LOADER_EXPORT___;
